import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import Img from 'gatsby-image'
import SiteMetadata from './SiteMetadata'
import ContactForm from './shortcodes/ContactForm'
import FooterStyles from '../styles/Footer.module.sass'

/**
 * Display the global footer
 *
 * @param {boolean} [showContactForm=true]
 */
const Footer = props => {
  const { title } = SiteMetadata()

  const image = useStaticQuery(imageQuery)

  return (
    <>
      {
        (props.showContactForm !== 'false' && props.showContactForm !== false) && 
          <div
            className={`is-clearfix contact-form-holder ${FooterStyles.contactFormHolder}`}
          >
            <div
              className={`container is-semi-narrow ${FooterStyles.contactFormContainer}`}
            >
              <ContactForm className={FooterStyles.form} />
              <div className={FooterStyles.image}>
                <Img
                  fluid={image.file.childImageSharp.fluid}
                  alt={title}
                  title={title}
                />
              </div>
            </div>
          </div>
      }

      <footer className={`footer ${FooterStyles.footer}`}>
        <div className="container has-text-centered is-semi-narrow">
          <p>
            Copyright{' '}
            <span className="current-year">{new Date().getFullYear()}</span>{' '}
            <strong>{title}</strong>. All rights reserved.
            <a href="https://specified.ie/" className={FooterStyles.signature || null}>Specified</a>
          </p>
        </div>
      </footer>
    </>
  )
}

export default Footer

export const imageQuery = graphql`
  {
    file(relativePath: { eq: "electric-vehicle-charging.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 600) {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`